import React, {useState, useRef, useEffect} from 'react'
import { useNavigate } from 'react-router-dom';
import { useSelector } from 'react-redux';
import { toast } from 'react-toastify';
import { Autocomplete, TextField } from '@mui/material';
import TDSitList from "../../../components/Reconciliation/TDSit/TDSitList";
import Spinner from "../../../components/Tools/spinner";
import SubHeader from "../../../components/Subheader/Subheader";
import CustomBreadcrumbs from "../../../components/Tools/Breadcumbs";
import { get_Tds_Section } from '../../../helper/Api';

const ALL_SECTIONS_OPTION = { id: '', section: 'All Sections' };

const TDSit = () => {
    const navigate = useNavigate();
    const {authData, financialYears}=useSelector((state)=>state.authData);
    const fyList = financialYears.payload.fy_list;
    const fyIdRef = useRef(localStorage.getItem('globalDateId'));
    const [selectedTDS,setSelectednvoice]=useState([])
    const [fromDate, setFromDate] = useState('');
    const [toDate, setToDate] = useState('');
    const [searchStr, setToSearchStr] = useState('');
    const [dateColumn, setDateColumn] = useState('voucher_date');
    const [loading, setLoading] = useState(false);
    const [tdsSections, setTdsSections] = useState([]);
    const [tdsSectionId, setTdsSectionId] = useState('');

    const sectionOptions = [ALL_SECTIONS_OPTION, ...tdsSections];
    const selectedSection =
        sectionOptions.find((item) => String(item?.id) === String(tdsSectionId || '')) ||
        ALL_SECTIONS_OPTION;

    useEffect(() => {
        const loadSections = async () => {
            try {
                const resp = await get_Tds_Section();
                setTdsSections(resp?.data?.list || []);
            } catch (error) {
                setTdsSections([]);
            }
        };
        loadSections();
    }, []);

    const handlePageTrigger = () => {
        fyIdRef.current = localStorage.getItem('globalDateId');
    }


    const handleDateChange = (start, end, dateColumn, searchStr) => {
        setFromDate(start);
        setToDate(end);
        setToSearchStr(searchStr);
        setDateColumn(dateColumn);
    };

    const handleAddChallan = () => {
        if (!selectedTDS.length) {
            toast.error('Please select at least one invoice', {
                position: toast.POSITION.TOP_CENTER,
            });
            return;
        }
        navigate('/add-tds-it', { state: { data: selectedTDS } });
    };

    return (
        <div>
            {loading && <Spinner />}
            <SubHeader fy_list={fyList} handlePageTrigger={handlePageTrigger}/>
            <div className="row" style={{ padding: "10px 16px" }}>
                <div className="col-md-6">
                    <h4 style={{ color: "#28326f", margin:0}}>TDS-IT</h4>
                    <CustomBreadcrumbs linksArray={[]} title="TDS-IT"/>
                </div>
                <div className="col-md-6">
                    <div
                        className="d-flex align-items-center gap-2"
                        style={{ width: "auto", float: "right" }}
                    >
                        <Autocomplete
                            size="small"
                            sx={{ minWidth: 240 }}
                            options={sectionOptions}
                            getOptionLabel={(option) => option?.section || ''}
                            isOptionEqualToValue={(option, value) =>
                                String(option?.id ?? '') === String(value?.id ?? '')
                            }
                            value={selectedSection}
                            onChange={(_event, selected) => {
                                setTdsSectionId(selected?.id != null ? String(selected.id) : '');
                            }}
                            renderInput={(params) => (
                                <TextField
                                    {...params}
                                    label="TDS Section"
                                    placeholder="Type to search section"
                                />
                            )}
                        />
                        <button
                            type="button"
                            className="submit_button"
                            onClick={handleAddChallan}
                        >
                            Add Challan
                        </button>
                    </div>
                </div>
            </div>
            <div className='scheme p-3'>
                <TDSitList
                    selectedInvoice={selectedTDS}
                    setSelectednvoice={setSelectednvoice}
                    dateColumn={dateColumn}
                    searchStr={searchStr}
                    fromDate={fromDate}
                    toDate={toDate}
                    tdsSectionId={tdsSectionId}
                    loading={loading}
                    setLoading={setLoading}
                />
            </div>
        </div>
    )
}

export default TDSit
